import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { gameDetailsActions } from '../../store/gameDetailsSlice';
import { userDetailsActions } from '../../store/userDetailsSlice';
import { useEffect } from 'react';
import { useGetUserByIdQuery } from '../../store/services/userServices';
import { LuUser, LuCalendarRange, LuMail, LuList, LuMapPin, LuPhone, LuContact2, LuContact, LuCreditCard } from "react-icons/lu";
import { CircularProgress } from '@mui/material';
import { winnerDetailsActions } from '../../store/winnerDetailsSlice';
import { receiptViewActions } from '../../store/receiptViewSlice';
import { useNavigate } from 'react-router';
import { FiList } from 'react-icons/fi';

const customStyles = {
    content: {
        position: 'static',
        borderRadius: '10px',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
};

Modal.setAppElement(document.getElementById('root'))

export default function WinnerDetails() {

    const user = useSelector(state => state.winner_details.data)
    const isOpen = useSelector(state => state.winner_details.isOpen)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { data: userData, isLoading, isError, isSuccess } = useGetUserByIdQuery(user.id || '', {
        skip: !user.id
    })

    const data = userData?.data || user;

    const closeModal = () => {
        dispatch(winnerDetailsActions.closeModal())
    }

    return (
        <div>
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="bg-white p-4 w-[360px] text-sm">
                    {isLoading ? <div className="flex justify-center items-center h-[480px]"><CircularProgress /></div> : (
                        <div className='flex flex-col gap-4 items-center'>
                            <div className='flex flex-col gap-2 items-center'>
                                <div className='w-14 h-14 rounded-full flex items-center justify-center border border-[#bbb]'>
                                    <LuUser color='#bbb' size={24} />
                                </div>
                                <div className='text-xl'>{user.first_name} {user.last_name}</div>
                            </div>
                            <hr className='w-full' />
                            <div className='flex flex-col gap-2 w-full text-sm'>
                                <div className='flex justify-between items-center'>
                                    {/* <div><LuContact color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs uppercase text-gray-500'>ID</div>
                                    <div className='text-xs font-medium'>{data?.user_id}</div>
                                </div>
                                <div className='flex justify-between items-center'>
                                    {/* <div><LuContact color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs uppercase text-gray-500'>Numri personal</div>
                                    <div className='text-xs font-medium'>{data?.personal_number}</div>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <div className='text-xs uppercase text-gray-500'>Numri i telefonit</div>
                                    {/* <div><LuPhone color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs font-medium'>{data?.phone_number}</div>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <div className='text-xs uppercase text-gray-500'>Email</div>
                                    {/* <div><LuMail color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs font-medium'>{data?.email}</div>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <div className='text-xs uppercase text-gray-500'>Ditëlindja</div>
                                    {/* <div><LuCalendarRange color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs font-medium'>{new Date(data?.birthdate).toLocaleDateString("en-GB")}</div>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <div className='text-xs uppercase text-gray-500'>Komuna</div>
                                    {/* <div><LuMapPin color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs font-medium'>{data?.municipality_name}</div>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <div className='text-xs uppercase text-gray-500'>Banka</div>
                                    {/* <div><LuCreditCard color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs font-medium'>{data?.bank_name}</div>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <div className='text-xs uppercase text-gray-500'>Numri i bankës</div>
                                    {/* <div><LuCreditCard color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs font-medium'>{data?.bank_account_number}</div>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <div className='text-xs uppercase text-gray-500'>Data e shpërblimit</div>
                                    {/* <div><LuCreditCard color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs font-medium'>{new Date(data?.created_at).toLocaleDateString('en-GB')}</div>
                                </div>
                            </div>
                            <hr className='w-full' />
                            <div className='flex flex-col gap-2 w-full text-sm'>
                                <div className='flex justify-between items-center'>
                                    {/* <div><LuContact color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs uppercase text-gray-500'>Loja</div>
                                    <div className='text-xs font-medium'>{data?.game_title}</div>
                                </div>
                                <div className='flex justify-between items-center'>
                                    {/* <div><LuContact color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs uppercase text-gray-500'>Kushti</div>
                                    <div className='text-xs font-medium'>{data?.tier_level}</div>
                                </div>
                                {/* The winning receipt comes from the list row; the user lookup doesn't carry it */}
                                <div className='flex justify-between items-center'>
                                    <div className='text-xs uppercase text-gray-500'>Kuponi fitues</div>
                                    {(user.receipt_id ?? data?.receipt_id) ? (
                                        <button
                                            type='button'
                                            className='text-xs font-medium text-blue-600 hover:text-blue-800 hover:underline'
                                            onClick={() => {
                                                const receiptId = user.receipt_id ?? data?.receipt_id
                                                dispatch(winnerDetailsActions.closeModal())
                                                dispatch(receiptViewActions.openModal({ receipt_id: receiptId }))
                                            }}
                                        >
                                            #{user.receipt_id ?? data?.receipt_id}
                                        </button>
                                    ) : (
                                        <div className='text-xs font-medium'>—</div>
                                    )}
                                </div>
                                <div className='flex justify-between items-center'>
                                    {/* <div><LuContact color='var(--secondary-color)' size={24} /></div> */}
                                    <div className='text-xs uppercase text-gray-500'>Kupona të dorëzuar</div>
                                    <div className='text-xs font-medium'>{data?.receipt_count}</div>
                                </div>
                            </div>
                            <hr className='w-full' />
                            <div className='flex flex-col gap-2 w-full text-sm'>
                                <div className='w-full p-2 font-bold text-center uppercase text-xs bg-secondary text-white leading-3 rounded-lg cursor-pointer flex items-center justify-center gap-2' onClick={() => {
                                    dispatch(winnerDetailsActions.closeModal())
                                    navigate(`/approved_receipts?user_id=${data.user_id}&game_id=${data.game_id}`)
                                }
                                }>
                                    <span><FiList size={18} /></span>
                                    <span>Shiko kuponat e dorëzuar</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
        </div>)
}